<template>
  <div class="feedback-btn">
    <!-- <div class="title">
      <van-nav-bar title="意见反馈">
        <van-icon name="arrow-left" slot="left" @click="Back()" />
      </van-nav-bar>
    </div> -->
    <div class="submission">
      <van-cell-group>
        <van-field @focus="()=>{this.faceShow = false;}" v-model="message" type="textarea" placeholder="说说您的问题" rows="1" maxlength="500" show-word-limit autosize />
      </van-cell-group>
      <div class="fb-btn">
        <div class="icon-img">
          <div v-for="(item, index) in gallerys" :key="index" class="pic-box">
            <van-image :src="item" width="80px" height="80px" fit="cover"></van-image>
            <div class="pic_delete">
              <van-image :src="picDelete" class="delImg" width="15px" height="15px" @click="Delete(index)"></van-image>
            </div>
          </div>
        </div>
      </div>
      <div style="position:relative" class="upload">
        <div @click="()=>{this.faceShow = false}">
          <van-uploader :multiple="true" :after-read="afterRead" :disabled="picDisabled" :max-count="6">
            <van-image :src="photoImg" class="icon-image"></van-image>
          </van-uploader>
        </div>

        <van-loading size="24px" v-if="loading">上传中...</van-loading>
        <van-image :src="expressionImg" @click="faceContent" class="imgFace"></van-image>
        <!-- 表情区域 -->
        <div class="browBox" v-if="faceShow">
          <ul>
            <li v-for="(item, index) in faceList" :key="index" @click="getBrow(index)">
              {{ item }}
            </li>
          </ul>
        </div>
        <van-button color="#2EBA73" @click="submitFeed" :disabled="isDisable">提交</van-button>
        <!-- <van-button color="#000" disabled v-if="!submissionBtn">提交</van-button> -->
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
const appData = require('@/assets/emojis.json');
export default {
  data() {
    return {
      message: '',
      photoImg: require('../../assets/iconImage/ic_pic@2x.png'),
      expressionImg: require('../../assets/iconImage/ic_em@2x.png'),
      fileList: [],
      gallerys: [], // 图片上传服务器
      faceShow: false,
      faceList: [],
      picDelete: require('../../assets/iconImage/icon_delate@2x.png'),
      picDisabled: false,
      loading: false,
      submissionBtn: true,
      isDisable: false,
      isSubmit: false, //是否提交
    };
  },
  mounted() {
    document.title = '意见反馈';
  },
  methods: {
    // 返回上一页
    Back() {
      this.$router.go(-1);
    },
    // 图片上传
    afterRead(file) {
      this.loadingImg = true;
      let params = [];
      if (Array.isArray(file) != true) {
        let newFile = [];
        newFile.push(file);
        file = newFile;
      }
      let n = 0;
      for (let i = 0; i < file.length; i++) {
        params.push(file[i].file);
        let fromData = new FormData();
        fromData.append('file', params[i]);
        this.$request
          .post('/appserver/v1/upload/image', fromData)
          .then((res) => {
            if (res.data.ret == 0) {
              n = n + 1;
              this.gallerys.push(res.data.data.fileUrl);
              this.gallerysLength = this.gallerys.length;
              if (this.gallerysLength >= 6) {
                this.picDisabled = true;
                this.gallerys.splice(6, this.gallerysLength - 6);
                this.submissionBtn = false;
                this.$toast('图片最多可6张');
                this.loading = false;
              }
              if (n == file.length) {
                this.$toast('上传成功！');
                this.loading = false;
              }
            } else {
              this.$toast(res.data.msg);
              this.loading = false;
            }
          })
          .catch((err) => {
            // eslint-disable-next-line
            this.$toast(err);
            this.loading = false;
          });
      }
    },
    // 删除图片
    Delete(index) {
      if (index != -1) {
        this.fileList.splice(index, 1);
        if (this.fileList.length < 6) {
          this.picDisabled = false;
        }
        this.gallerys.splice(index, 1);
      }
    },
    // 表情
    faceContent() {
      this.faceShow = !this.faceShow;
      if (this.faceShow == true) {
        for (let i in appData) {
          this.faceList.push(appData[i].char);
        }
      } else {
        this.faceList = [];
      }
    },
    // 获取用户点击之后的标签 ，存放到输入框内
    getBrow(index) {
      for (let i in this.faceList) {
        if (index == i) {
          this.getBrowString = this.faceList[index];
          this.message += this.getBrowString;
        }
      }
      // console.log(this.message)
      this.faceShow = false;
      if (this.message === '') {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
    },
    // 上传
    submitFeed() {
      if (this.message == '') {
        this.$toast({
          message: '请填写反馈信息',
          duration: '2000',
        });
      } else {

        if (this.isSubmit) {
          //触发重复提交
          return;
        }
        this.isSubmit = true;
        let data = {
          opinionQuestion: this.message,
          userId: localStorage.getItem('uid'),
          // userId:'12',
          gallerys: this.gallerys,
        };

        this.$request.post('/appserver/v1/opinion/save', data).then((data) => {
          if (data.data.ret === 0) {
            this.isSubmit = true;
            this.$toast({
              message: '已提交',
              duration: '1000',
            });
            this.isDisable = true;
            setTimeout(() => {
              this.isDisable = false;
            }, 500);
            // this.submissionBtn = false;
            // setTimeout(() => {
            //   this.$router.push({ path: '/feedback' });
            // }, 500);
            this.$router.go(-1);
          } else {
            this.$toast(data.data.msg);
            this.isSubmit = false;
            // this.submissionBtn = false;
            this.isDisable = true;
            setTimeout(() => {
              this.isDisable = false;
            }, 500);
          }
        }).catch(e => {
          this.$toast(e);
          this.isSubmit = false;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.feedback-btn {
  background: #f6f6f6;
  height: 100%;
  .title {
    box-shadow: 0px -3px 8px #eee;
    margin-bottom: 1px;
    /deep/ .van-nav-bar .van-icon {
      color: #4a4a4a;
      font-size: 22px;
      font-weight: 600;
    }
    /deep/ .van-nav-bar__title {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
    }
    /deep/ [class*="van-hairline"]::after {
      border: 0px;
    }
  }
  .submission {
    position: relative;
    background: #fff;
    padding: 15px;
    padding-bottom: 20px;
    /deep/ .van-hairline--top-bottom::after {
      border: 0px;
    }
    /deep/ .van-cell {
      padding: 0px;
    }
    /deep/ .van-field__control {
      min-height: 100px !important;
    }
    /deep/ .vant-field_body textarea {
      -webkit-user-select: auto;
    }
    .fb-btn {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      margin-top: 15px;
      .icon-img {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .pic-box {
          position: relative;
          width: 80px;
          height: 80px;
          margin-right: 15px;
        }
        .icon-image {
          width: 20px;
          height: 20px;
        }
        .pic_delete {
          position: absolute;
          top: -6.5px;
          right: -6.5px;
          .delImg {
            width: 15px;
            height: 15px;
          }
        }
      }
      .faceImg {
        position: absolute;
      }
    }

    .upload {
		div{
			display: inline-block;
		}
      /deep/ .van-loading {
        position: absolute;
        left: 40%;
        margin-top: 20px;
      }
    }
    /deep/ .van-button {
      position: absolute;
      right: 10px;
      bottom: 10%;
      width: 50px;
      height: 30px;
      // border: 0px;
      border-radius: 3px;
      line-height: 30px;
      // font-size: 15px;
      background: #188357;
      color: #fff;
      padding: 0;
    }
    /deep/.van-uploader__input-wrapper {
      width: 20px;
      height: 20px;
      display: inline-block;
    }
    .browBox {
      position: absolute;
      right: 0px;
	  bottom: 0;
      // top: 240px;
	  transform: translateY(100%);
      width: 100%;
      height: 200px;
      background: #e6e6e6;
      overflow: scroll;
      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
        li {
          width: 14%;
          font-size: 26px;
          list-style: none;
          text-align: center;
        }
      }
    }
  }
}
.imgFace {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}
</style>
